import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import LinkTypography from '@jobcase/react_pattern_library/components/Link/LinkRebrand';
import styles from '@jobcase/react_pattern_library/styles/rebrand';
import Typography from '@jobcase/react_pattern_library/components/Typography/TypographyRebrand';

import BarredText from '../../../components/SSO/BarredText';
import NativeSignup from '../../../components/SSO/NativeSignup';
import SocialSignIn from '../../../components/SSO/SocialSignIn';

const CustomHeader = styled.div`
  margin-bottom: ${({ theme }) => `${theme.spacing.default}px`};
  text-align: left;
`;

const LoginLink = styled(LinkTypography)`
  border: 0;
  color: ${styles.color.primaryColor};
  margin: 0;
  padding: 0;
`;

const Signup = ({
  onSignupSuccess,
  isLoginVisible,
  onVisibleLogin,
  onFormChange,
}) => {
  const handleSignupSuccess = (signOnType) => {
    if (onSignupSuccess) {
      onSignupSuccess(signOnType);
    }
  };

  return (
    <>
      <CustomHeader>
        <LoginLink onClick={() => onVisibleLogin()} variant={Typography.VARIANTS.H3}>
          Already a member? Login
        </LoginLink>
      </CustomHeader>
      <SocialSignIn onLoginSuccess={handleSignupSuccess} isLoginVisible={isLoginVisible} />
      <BarredText />
      <NativeSignup onSignupSuccess={handleSignupSuccess} onFormChange={onFormChange} />
    </>
  );
};

Signup.propTypes = {
  onSignupSuccess: PropTypes.func,
  onVisibleLogin: PropTypes.func,
  onFormChange: PropTypes.func,
  isLoginVisible: PropTypes.bool,
};

Signup.defaultProps = {
  onSignupSuccess: null,
  onVisibleLogin: null,
  onFormChange: () => {},
  isLoginVisible: false,
};

export default Signup;
